<template>
  <el-popover placement="bottom" trigger="click" ref="popoverRef" v-model="currentValue" popper-class="cross-select-body" :popper-options="popoverOption">
    <span slot="reference">
      <div class="el-select cross-select-input" @mouseover="hoverInput" @mouseleave="leaveInput">
        <div class="el-select__tags">
          <span>
            <span class="el-tag el-tag--info el-tag--small el-tag--light" v-for="(item, index) in memberList" :key="item.uid">
              <span class="el-select__tags-text">{{item.name}}</span>
              <i class="el-tag__close el-icon-close" @click.stop="delItem(index)"></i>
            </span>
          </span>
        </div>
        <div class="el-input el-input--suffix">
          <input type="text" readonly="readonly" autocomplete="off" placeholder="请选择" class="el-input__inner">
          <span class="el-input__suffix">
            <span class="el-input__suffix-inner">
              <i class="el-input__icon el-icon-circle-close el-input__clear" v-show="isShow" @click.stop="clearData"></i>
              <i class="el-select__caret el-input__icon el-icon-arrow-up" :class="{'is-reverse':currentValue}" v-show="!isShow"></i>
            </span>
          </span>
        </div>
      </div>
    </span>
    <ParticipantList @close="currentValue = false" v-model="selectedData" @confirm="confirm" :taskMemberlist="optionArr" :lockUid="[]"></ParticipantList>
  </el-popover>
</template>
<script>
import ParticipantList from '@/views/customKeyPage/components/participant/participantList'
function createdCascaderData(sourceData, fl) {
  return sourceData.map(item => {
    let temp = {}
    temp["uid"] = item.uid || (item.depart_id + '_depart')
    temp["realname"] = item.name || item.realname
    if (item.member && item.member.length > 0) {
      temp["children"] = createdCascaderData(item.member, true)
    } else {
      temp["children"] = null
      temp.disabled = !fl
    }
    return temp
  })
}
// 平铺数据
function tileData(dataList) {
  let arr = [];
  dataList.forEach(item => {
    if(item.children && item.children.length > 0){
      arr = [...arr, ...item.children];
    }
  });
  return arr;
}
export default {
  components: {
    ParticipantList
  },
  props: {
    value: {
      type: [Boolean, Array],
      default: false
    },
    selectedData: {
      type: Array,
      default: () => {
        return []
      }
    },
    options: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    },
    memberList() {
      let checkNode = tileData(this.optionArr)
      let arr = checkNode.map(item => {
        if (this.selectedData.find(temp => temp.uid === item.uid)) {
          return {
            userId: item.uid,
            name: item.realname,
            user_avatar: item.user_avatar
          }
        }
      }).filter(res => res)
      return arr
    },
    optionArr() {
      return createdCascaderData(this.options)
    }
  },
  data() {
    return {
      isShow: false,
      popoverOption: {
        offset: [40, 0],
        boundariesElement: 'viewport',
        gpuAcceleration: false
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.popoverRef.updatePopper()
    })
  },
  methods: {
    confirm(val) {
      this.currentValue = false
      this.$emit('confirm', val)
    },
    hoverInput() {
      if(this.selectedData && this.selectedData.length > 0) {
        this.isShow = true
      }
    },
    leaveInput() {
      this.isShow = false
    },
    delItem(index) {
      let arr = JSON.parse(JSON.stringify(this.selectedData))
      arr.splice(index, 1)
      this.$emit('confirm', arr)
    },
    clearData() {
      this.$emit('confirm', [])
    }
  }
}
</script>
<style lang="scss">
.cross-select-body[x-placement^="bottom"] {
  margin-top: 32px;
}
.cross-select-input{
  .el-select__tags{
    max-width: 90%;
    overflow: hidden;
    &>span {
      display: flex;
    }
  }
}
</style>
